<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '~/helpers'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <tr :class="cn('border-b transition-colors data-[state=selected]:bg-[#CFEAFF]', props.class)">
    <slot />
  </tr>
</template>
